import { render, staticRenderFns } from "./BrainstormVotingSticker.vue?vue&type=template&id=9a7294de&scoped=true&"
import script from "./BrainstormVotingSticker.vue?vue&type=script&lang=js&"
export * from "./BrainstormVotingSticker.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormVotingSticker.vue?vue&type=style&index=0&id=9a7294de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7294de",
  null
  
)

export default component.exports